<script>
import { Line } from 'vue-chartjs'

export default {
    extends: Line,
    props: {
        labels: {
            type: Array,
            required: true
        },
        datasets: {
            type: Array,
            required: true
        },
        yLabel: {
            type: String,
            required: false,
            default: ''
        },
        yAxesAdditional: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    mounted() {
        this.renderChart(
            {
                labels: this.labels,
                datasets: this.datasets,
            },
            {
                defaultFontColor: '#8791af',
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                color: 'rgba(166, 176, 207, 0.1)',
                            },
                            ticks: {
                                autoSkip: true,
                                autoSkipPadding: 40
                            }
                        },
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                color: 'rgba(166, 176, 207, 0.1)',
                            },
                            scaleLabel: {
                                display: true,
                                labelString: this.yLabel
                            }
                        },
                        this.yAxesAdditional
                    ],
                },
                legend: {
                    position: 'bottom'
                }
            }
        )
    },
}
</script>